// REACT_APP_API_BASE="" sends API calls to the page origin (through setupProxy.js), e.g. behind a tunnel.
export const API_BASE = process.env.REACT_APP_API_BASE ?? (process.env.REACT_APP_PROXY || 'http://localhost:8080');
